import { ReactElement, useEffect } from 'react';
import styled from 'styled-components';

import { FeedbackNotificationError } from 'components/feedback-notification';

const ToastContainer = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  max-width: 90%;
`;

type FlowErrorToastProps = {
  message: string | null;
  onDismiss: () => void;
  /** Auto-dismiss delay in ms. */
  duration?: number;
};

/**
 * Auto-dismissing error toast for `submit:error`, layered over the iframe.
 * Reuses the shared FeedbackNotificationError so styling follows the theme.
 */
const FlowErrorToast = ({ message, onDismiss, duration = 5000 }: FlowErrorToastProps): ReactElement | null => {
  useEffect(() => {
    if (!message) return undefined;
    const id = setTimeout(onDismiss, duration);
    return () => clearTimeout(id);
  }, [message, duration, onDismiss]);

  if (!message) return null;
  return (
    <ToastContainer>
      <FeedbackNotificationError message={message} hasCloseIcon onClose={onDismiss} />
    </ToastContainer>
  );
};

export default FlowErrorToast;
